// src/pages/account/CustomerProfilePage.js
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import AccountDetails from '../../components/account/AccountDetails';
import PasswordSettings from '../../components/account/PasswordSettings';
import BillingSettings from '../../components/account/BillingSettings';
import './Account.css';
const API_URL = process.env.REACT_APP_API_URL;
const CustomerProfilePage = () => {
  const { t } = useTranslation();
  const { token, user } = useAuth();
  
  const [activeTab, setActiveTab] = useState('details');
  
  // DEĞİŞİKLİK: Tüm form verileri artık bu üst bileşende tutuluyor.
  const [formData, setFormData] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Sadece bir kere, sayfa yüklendiğinde tüm kullanıcı verilerini çek.
  useEffect(() => {
    const fetchProfile = async () => {
      if (!token || !user) { setLoading(false); return; }
      try {
        setLoading(true); setError('');
        const response = await fetch(`${API_URL}/api/auth/me`, { 
            headers: { 'Authorization': `Bearer ${token}` } 
        });
        if (!response.ok) throw new Error(t('error_fetch_profile'));
        const data = await response.json();
        
        // Fatura bilgileri JSON string'i ise objeye çevir
        if (data.billing_details && typeof data.billing_details === 'string') {
            data.billing_details = JSON.parse(data.billing_details);
        } else if (!data.billing_details) {
            data.billing_details = {}; // Boşsa, boş bir obje ata
        }
        
        setFormData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [token, user, t]);

  const handleFormChange = (newData) => {
      setFormData(prev => ({...prev, ...newData}));
  };

  const renderContent = () => {
    if (loading) return <div><i className="fas fa-spinner fa-spin"></i> {t('loading_profile')}</div>;
    if (error) return <div className="error">{error}</div>;

    switch (activeTab) {
      case 'details': 
        return <AccountDetails formData={formData} onFormChange={handleFormChange} />;
      case 'password': 
        return <PasswordSettings />;
      case 'billing': 
        return <BillingSettings formData={formData} onFormChange={handleFormChange} />;
      default: 
        return <AccountDetails formData={formData} onFormChange={handleFormChange} />;
    }
  };

  return (
    <div className="page-container account-page-my-account">
      <h1>{t('dashboard_profile', 'Profilim')}</h1>
      <div className="profile-layout">
        <aside className="profile-sidebar">
          <nav>
            <button onClick={() => setActiveTab('details')} className={activeTab === 'details' ? 'active' : ''}>{t('account_details')}</button>
            <button onClick={() => setActiveTab('password')} className={activeTab === 'password' ? 'active' : ''}>{t('password')}</button>
            <button onClick={() => setActiveTab('billing')} className={activeTab === 'billing' ? 'active' : ''}>{t('billing_info')}</button>
          </nav>
        </aside>
        <main className="profile-content">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default CustomerProfilePage;